import React, { lazy } from 'react'
import { Route } from 'react-router'
import { Routes } from 'react-router-dom'

import AppLayout from './components/layouts/AppLayout'
import AuthLayout from './components/layouts/AuthLayout'
import { ROUTES } from './constants/routes'
import { usePageViewListener } from './hooks/usePageViewListener'

const NotFoundPage = lazy(() => import('./pages/404/NotFoundPage'))
const AccountPage = lazy(() => import('./pages/account/index/AccountPage'))
const UpdatePasswordPage = lazy(
  () => import('./pages/account/updatePassword/UpdatePasswordPage'),
)
const ForgotPasswordPage = lazy(
  () => import('./pages/auth/forgot-password/ForgotPasswordPage'),
)
const LoginPage = lazy(() => import('./pages/auth/login/LoginPage'))
const RegisterPage = lazy(() => import('./pages/auth/register/RegisterPage'))
const ResetPasswordPage = lazy(
  () => import('./pages/auth/reset-password/ResetPasswordPage'),
)
const AddContactPage = lazy(() => import('./pages/contacts/add/AddContactPage'))
const ContactDetailsPage = lazy(
  () => import('./pages/contacts/details/ContactDetailsPage'),
)
const EditContactPage = lazy(
  () => import('./pages/contacts/edit/EditContactPage'),
)
const ContactListPage = lazy(
  () => import('./pages/contacts/list/ContactListPage'),
)
const DebugReleasePage = lazy(
  () => import('./pages/debug/release/DebugReleasePage'),
)
const DebugSentryPage = lazy(
  () => import('./pages/debug/sentry/DebugSentryPage'),
)
const IndexPage = lazy(() => import('./pages/index/IndexPage'))
const AddTagPage = lazy(() => import('./pages/tags/add/AddTagPage'))
const TagDetailPage = lazy(() => import('./pages/tags/details/TagDetailPage'))
const EditTagPage = lazy(() => import('./pages/tags/edit/EditTagPage'))
const TagsListPage = lazy(() => import('./pages/tags/list/TagsListPage'))

const AppRoutes: React.FC = () => {
  usePageViewListener()

  return (
    <Routes>
      <Route path="" element={<IndexPage />} />

      <Route element={<AuthLayout />}>
        {/* Auth */}
        <Route path={ROUTES.login} element={<LoginPage />} />
        <Route path={ROUTES.register} element={<RegisterPage />} />
        <Route path={ROUTES.forgotPassword} element={<ForgotPasswordPage />} />
        <Route path={ROUTES.resetPassword} element={<ResetPasswordPage />} />
      </Route>

      <Route element={<AppLayout />}>
        {/* Account */}
        <Route path={ROUTES.account} element={<AccountPage />} />
        <Route path={ROUTES._updatePassword} element={<UpdatePasswordPage />} />

        {/* Contacts */}
        <Route path={ROUTES._contactList} element={<ContactListPage />} />
        <Route path={ROUTES._contactDetails} element={<ContactDetailsPage />} />
        <Route path={ROUTES.contacts.add} element={<AddContactPage />} />
        <Route path={ROUTES.contacts.edit} element={<EditContactPage />} />

        {/* Debug */}
        <Route path={ROUTES._debugRelease} element={<DebugReleasePage />} />
        <Route path={ROUTES._debugSentry} element={<DebugSentryPage />} />

        {/* Debug */}
        <Route path={ROUTES._tagList} element={<TagsListPage />} />
        <Route path={ROUTES._tagDetails} element={<TagDetailPage />} />
        <Route path={ROUTES._addTag} element={<AddTagPage />} />
        <Route path={ROUTES._editTag} element={<EditTagPage />} />

        {/* Misc */}
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export default AppRoutes
